import React from 'react';
import classNames from 'classnames';


import styles from './style.scss';
import DateView from '../DateView';
import ItemView from '../ItemView';
import StatusView from '../StatusView';
import TypeView from '../TypeView';
import PeriodView from '../PeriodView';
import PaymentView from '../PaymentView';


class AccordionItem extends React.Component {
  constructor(props) {
    super(props);
    this.getBook = this.getBook.bind(this);
    this.state = {
      opened: false,
      bookInfo: {},
    };
  }

  getBook(data) {
    this.setState({
      bookInfo: data,
    });
  }

  render() {
    const {
      props: {
        item,
        date,
        type,
        period,
        cost,
        payment,
        status,
        recipe,
      },
      state: {
        opened,
        bookInfo,
      },
    } = this;

    return (
      <div
        className={classNames(styles.accordionItem, opened && styles.accordionItemOpened)}
        onClick={() => {
          this.setState({ opened: !opened });
        }}>
        <div className={styles.accordionItemLine}>
          <div className={styles.header}>
            <ItemView item={item} accordion getBook={this.getBook} />
            <div className={styles.date}><DateView date={date.created} payedTill={date.payedTill} /></div>
          </div>
          <span className={styles.accordionItemIcon} />
        </div>
        <div className={styles.accordionItemInner}>
          {bookInfo.name
          &&
          <div className={styles.linkWrapper}>
            <a href={bookInfo.absolute_url} className={styles.link}>
              «{bookInfo.name}» &nbsp;{bookInfo.main_author.cover_name}
            </a>
          </div>
          }
          <div className={styles.accordionItemContent}>Доступ <TypeView type={type} /></div>
          <div className={styles.accordionItemContent}>Период <PeriodView date={period} /></div>
          <div className={styles.accordionItemContent}>Стоимость <div>{cost}</div></div>
          <div className={styles.accordionItemContent}>Оплата <PaymentView type={payment} /></div>
          <div className={styles.accordionItemContent}>Статус <StatusView status={status} /></div>
          {recipe &&
          <div className={styles.accordionItemContent}>
            Чек <a href={recipe} className={styles.link}>Кассовый чек</a>
          </div>
          }
        </div>
      </div>
    );
  }
}

export default AccordionItem;
